








































import { Component, Prop, Vue } from 'vue-property-decorator'

import { UnitSelection } from '@/_consts/UnitStoreAction'
import UnitModel from '@/_models/UnitModel'

@Component({
  components: {},
})
export default class AskForDetele extends Vue {
  @Prop() public data!: any
  @Prop() public hasRef!: boolean
  @Prop() public type!: UnitSelection
  @Prop() public idsProp!: string[]
  @Prop() public unit!: UnitModel

  public onProcessDelete() {
    if (this.hasRef) {
      const payload = {unit: { db_name: this.unit.db_name }, ids: this.idsProp, collection: this.type}

      this.$store.dispatch('units/hasRefsCollection', payload).then((result) => {
        if (result.has_reference) {
          this.confirmForceDelete()
        } else {
          this.emitDeleteEvent()
        }
      })
    } else {
      this.emitDeleteEvent()
    }
  }

  public confirmForceDelete(): void {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t(
        'messages.has_refs_data_are_you_sure_want_to_delete'
      ) as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.emitDeleteEvent()
      },
    })
  }

  public emitDeleteEvent() {
    this.$emit('onDelete')
    this.$emit('close')
  }
}
